import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/execution/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/execution')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Execution',
    tabKey: 'agreement/execution',
  },
  pendingComponent: Loading,
});
